import * as ClientTypes from './ApiVerify-v1/types';

/** The raw response from `login-verify/hub-user-info`.
 *
 * This should only be used by passing to {@link transformUserInfoResponse}.
 */
export interface InternalVerifyResponse extends ClientTypes.VerifyResponse {
  // this field is not present in the schema, but was referenced in the userInfo response handler.
  // does it actualy exist? I have no idea.
  auth?: unknown;
}

/** The raw response from `login-verify/user-info`.
 *
 * This should only be used by passing to {@link transformHublessUserInfoResponse}. */
export type InternalHublessVerifyResponse = ClientTypes.HublessVerifyResponse;

export type HublessVerifyResponse = Omit<
  InternalHublessVerifyResponse,
  'enabledV3Gates'
>;

export type PortalInfo = Omit<
  ClientTypes.PortalInfo,
  'enabled_gates' | 'enabled_v3_gates'
> & {
  enabled_gates: string[];
};

export type VerifyResponse = Pick<InternalVerifyResponse, 'user' | 'auth'> & {
  gates: string[];
  portal: PortalInfo;
};

function transformGates(
  v2Gates: string[] | null | undefined,
  v3Gates: string[] | null | undefined
) {
  return [
    ...(v2Gates || []),
    ...(v3Gates || []).map(
      (gate) =>
        // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
        `g8:${gate}`
    ),
  ];
}

export function transformHublessUserInfoResponse(
  response: InternalHublessVerifyResponse
): HublessVerifyResponse {
  const { enabledGates, enabledV3Gates, ...responseWithoutGates } = response;
  return {
    ...responseWithoutGates,
    enabledGates: transformGates(enabledGates, enabledV3Gates),
  };
}

export function transformUserInfoResponse({
  auth,
  portal,
  user,
}: InternalVerifyResponse): VerifyResponse {
  const {
    enabled_gates: enabledGates,
    enabled_v3_gates: enabledV3Gates,
    ...portalWithoutGates
  } = portal;
  const gates = transformGates(enabledGates, enabledV3Gates);

  const info: VerifyResponse = {
    user,
    gates,
    portal: {
      ...portalWithoutGates,
      enabled_gates: gates,
    },
  };

  if (auth) {
    info.auth = auth;
  }

  return info;
}
